import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import RequestPasswordResetPage from "@/pages/RequestPasswordResetPage";
import SetPasswordPage from "@/pages/SetPasswordPage";
import OverviewPage from "@/pages/OverviewPage";
import CodesPage from "@/pages/CodesPage";
import SubscriptionsPage from "@/pages/SubscriptionsPage";
import ReportsRevenuePage from "@/pages/ReportsRevenuePage";
import TutorialsPage from "@/pages/TutorialsPage";
import UsersPage from "@/pages/UsersPage";
import { DashboardLayout } from "@/components/DashboardLayout";
import { OwnerOnlyRoute, ProtectedRoute } from "@/components/ProtectedRoute";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
        toastOptions={{
          style: { fontSize: "13px" },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<RequestPasswordResetPage />} />
          <Route path="/set-password/:token" element={<SetPasswordPage />} />
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="/overview" element={<OverviewPage />} />
            <Route path="/codes" element={<CodesPage />} />
            <Route path="/subscriptions" element={<SubscriptionsPage />} />
            <Route path="/grants" element={<Navigate to="/subscriptions" replace />} />
            <Route path="/reports/revenue" element={<ReportsRevenuePage />} />
            <Route path="/tutorials" element={<TutorialsPage />} />
            <Route
              path="/users"
              element={
                <OwnerOnlyRoute>
                  <UsersPage />
                </OwnerOnlyRoute>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
